import axios from 'axios';
import moment from 'moment';
import {
    rrulestr
} from 'rrule';
import { CELL_TYPES } from './../models/dashboard';
import {
    eodErrorsDialog,
} from './../components';
import getEnv from './utils';
import vuetify from './vuetify';
import helper from './helper';
import Template from './../models/template';
import Task from './../models/task';
import Availability from './../models/availability';
import User from './../models/user';
import MeasurementType from './../models/measurementType';
import Vue from 'vue';

const _ = require('lodash');

export default {
    get mobile_url() {
        return getEnv('VUE_APP_MOBILE_URL');
    },
    get processor_url() {
        const api_url = getEnv('VUE_APP_API_URL');
        if (api_url.includes('//')) {
            return getEnv('VUE_APP_API_URL');
        }
        return location.protocol + '//' + getEnv('VUE_APP_API_URL');
    },
    get backend_url() {
        const backend_url = getEnv('VUE_APP_BACKEND_URL');
        if (backend_url.includes('//')) {
            return getEnv('VUE_APP_BACKEND_URL');
        }
        return location.protocol + '//' + backend_url;
    },
    get api_url() {
        return this.processor_url + '/private/' + this.getRealm();
    },
    get graphql_url() {
        return this.backend_url + '/graphql';
    },
    user: null,
    token: null,
    setToken(token) {
        this.token = token;
        axios.defaults.headers.common = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    },
    loginUser(token) {
        return new Promise((resolve, reject) => {
            this.setToken(token);

            this.user = User.fromJWT(token, this.getRealm());
            this.loadUser(this.user.id).then(() => {
                resolve(this.user);
            })

        });
    },
    loadUser() {
        return this.getById('user', this.user.id, ['id groups{id name} configuration'])
            .then(response => {
                if (response.data.data && response.data.data.user) {
                    this.user.groups = response.data.data.user.groups;
                    this.user.configuration = response.data.data.user.configuration;
                }

                return this.loadUserOrganization();
            });
    },
    loadUserGroups() {
        this.getById('user', this.user.id, ['id groups{id name}'])
            .then(response => {
                if (response.data.data && response.data.data.user) {
                    this.user.groups = response.data.data.user.groups;
                }
            });
    },
    setUserConfiguration(configName, value) {
        const user = this.getUser();
        const configuration = user.configuration ?? {};
        configuration[configName] = value;

        return this.save('User', {
            id: user.id,
            configuration: configuration,
        }).then(() => {
            return this.loadUser();
        });
    },
    getUser() {
        return this.user;
    },
    getToken() {
        return this.token;
    },
    setToken(token) {
        this.token = token;
        axios.defaults.headers.common = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
        this.user = User.fromJWT(token, this.getRealm());
    },
    loadUserOrganization() {
        let organization = null;
        return this.getById('resolveOrganization', this.user.organization.id, ['id name description configuration{version}']).then(response => {
            organization = response.data.data.resolveOrganization;
            if (!organization.configuration) {
                organization.configuration = {
                    settings: [],
                    version: '0.0'
                };
            }

            return organization;
        }).then(() => {
            return this.loadOrganizationSettings();
        }).then((settings) => {
            organization.configuration.settings = Object.values(settings);
            this.user.organization = organization;
            return this.user.organization;
        });
    },
    getOrganization() {
        return this.user.organization;
    },
    setOrganization(organization) {
        this.user.organization = organization;
    },
    ORGANIZATION_SETTINGS: {},
    loadOrganizationSettings() {
        return this.get('organizationSettings', ['key', 'value', 'label', 'isDefault', 'type'], {
            orderBy: {
                column: 'key',
                type: 'asc'
            },
        }).then(response => {
            if (response.data.data && response.data.data.organizationSettings) {
                for (let i = 0; i < response.data.data.organizationSettings.edges.length; i++) {
                    const setting = response.data.data.organizationSettings.edges[i];
                    this.ORGANIZATION_SETTINGS[setting.key] = setting;
                }

                return this.ORGANIZATION_SETTINGS;
            }

            return [];
        })
    },
    getOrganizationSetting(key) {
        let setting = { value: null };
        if (this.ORGANIZATION_SETTINGS[key]) {
            setting = { ...this.ORGANIZATION_SETTINGS[key] };

            if (setting.type == 'boolean') {
                setting.value = setting.value == 'true';
            }
        }

        return setting;
    },
    saveOrganizationSetting(key, value) {
        return this.update('OrganizationSetting', {
            key: key,
            value: value,
            organizationId: this.getUser().organizationId
        }, {
            returnfields: ['key']
        });
    },
    uploadImage(options) {
        return axios.post(this.api_url + '/storageObjects/image', options);
    },
    _LANGUAGES: null,
    getLanguages() {
        if (!this._LANGUAGES) {
            let languages = [];
            const languagesSetting = this.getOrganizationSetting('languages');

            if (languagesSetting && languagesSetting.value) {
                languages = JSON.parse(languagesSetting.value);
            }

            languages.sort(function (x, y) {
                return (x.isDefault === y.isDefault) ? 0 : x.isDefault ? -1 : 1;
            });

            this._LANGUAGES = languages;
        }

        return this._LANGUAGES;
    },
    _DEFAULT_LANGUAGE: null,
    getDefaultLanguage() {
        if (!this._DEFAULT_LANGUAGE) {
            const languages = this.getLanguages();
            for (let i = 0; i < languages.length; i++) {
                const language = languages[i];
                if (language.isDefault) {
                    this._DEFAULT_LANGUAGE = language;
                    break;
                }
            }
        }
        return this._DEFAULT_LANGUAGE;
    },
    getRealm() {
        if (getEnv('VUE_APP_REALM')) {
            return getEnv('VUE_APP_REALM');
        } else {
            var hostname = window.location.hostname;
            var hostparts = hostname.split('.');
            return hostparts[0];
        }
    },
    getImageUrl(image) {
        return this.api_url + '/eodstorage/' + image;
    },
    getFormUrl(taskid) {
        return 'https://' + this.getRealm() + '.' + this.mobile_url + '/form/' + taskid;
    },
    getCancelRequest() {
        return axios.CancelToken.source();
    },
    graphql(query, variables, options) {
        let data = {
            query: query
        }

        if (variables) {
            data.variables = variables;
        }

        if (!options) {
            options = {};
        }

        return axios.post(this.graphql_url, data, {
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            decompress: false,
            ...options
        }).then(response => {

            if (response.data.errors) {
                //this.throwErrors(response.data.errors);
                const userErrors = [];
                for (let i = 0; i < response.data.errors.length; i++) {
                    const error = response.data.errors[i];
                    if (error.extensions && error.extensions.code == 'USER_ERROR') {
                        userErrors.push(error);
                    }
                }
                if (userErrors[0]) {
                    this.throwUserError(userErrors);
                    return null;
                }
            }

            return response;
        }).catch(err => {
            if (!(err.code && err.code == 'ERR_CANCELED')) {
                if (err.response) {
                    this.throwErrors(err.response.data.errors);
                } else {
                    if (err.message != 'Fout bij verwerken van de aanvraag.') {
                        this.throwErrors([err]);
                    }

                }
                throw err;
            }
        });
    },
    // Robuuste save tijdens het sluiten van de tab/het venster: native fetch met
    // keepalive, want axios (XHR) negeert keepalive en wordt door de browser
    // afgebroken bij unload. Een unload-handler kan niet awaiten → fire-and-forget.
    // Let op: de keepalive-body is gelimiteerd tot 64KB; bij overschrijding is dit
    // best effort (portal-detailpayloads blijven ruim onder die limiet).
    graphqlKeepalive(query, variables) {
        try {
            return fetch(this.graphql_url, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': axios.defaults.headers.common['Authorization']
                },
                body: JSON.stringify({
                    query: query,
                    variables: variables
                })
            });
        } catch (err) {
            console.error('keepalive save failed', err);
        }
    },
    throwUserError(errors) {
        var ComponentClass = Vue.extend(eodErrorsDialog);
        var instance = new ComponentClass({
            vuetify,
            propsData: {
                title: 'Oeps, er is iets fout gelopen',
                value: true,
                errors: errors
            },
        });

        const mountNode = window.document.createElement('div');
        window.document.getElementById('app').appendChild(mountNode);
        instance.$mount(mountNode);
    },
    throwErrors(errors) {
        let error_env = ['staging', 'test', 'development', 'dev'];
        if (error_env.includes(getEnv('NODE_ENV'))) {
            var ComponentClass = Vue.extend(eodErrorsDialog);
            var instance = new ComponentClass({
                vuetify,
                propsData: {
                    title: 'Fout!',
                    value: true,
                    errors: errors,
                    isDev: true
                }
            });

            const mountNode = window.document.createElement('div');
            window.document.getElementById('app').appendChild(mountNode);
            instance.$mount(mountNode);
        }
    },
    stats(modulename) {
        let query = 'query stat' + modulename + '($input: StatInput){stat' + modulename + '(input: $input){stat}}';
        return this.graphql(query);
    },
    count(modulename, variables, options) {
        let query = 'query ' + modulename + '($input: CountInput){' + modulename + '(input: $input){totalCount}}';

        if (variables) {
            variables = {
                input: variables
            }
        }

        return this.graphql(query, variables, options);
    },
    getProcessor(endpoint) {
        return axios.get(this.api_url + endpoint);
    },
    post(endpoint, data) {
        return axios.post(this.api_url + endpoint, data, {
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
        });
    },
    dashboard(endpoint, data, options) {

        if (!options) {
            options = {};
        }

        return axios.post(this.api_url + '/dashboard/' + endpoint, data, {
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            decompress: false,
            ...options
        }).then(response => {
            return response;
        });
    },
    get(modulename, fields, variables, options) {

        let edges = '';
        if (fields) {
            edges = '{' + fields.join("\n") + '}';
        }

        let query = 'query list' + (modulename.charAt(0).toUpperCase() + modulename.slice(1)) + '($input: QueryInput){' + modulename + '(input: $input){totalCount edges' + edges + '}}';



        if (!variables) {
            variables = {
                input: {
                    orderBy: {
                        column: "name",
                        type: "asc"
                    }
                }
            }
        } else {
            variables = {
                input: variables
            }
        }

        return this.graphql(query, variables, options);
    },
    async getLatLng(filters) {
        // Get organization setting for lat and lng
        const measurementTypeLatId = this.getOrganizationSetting('measurementTypes.latitudeId')?.value;
        const measurementTypeLonId = this.getOrganizationSetting('measurementTypes.longitudeId')?.value;
        if (!measurementTypeLatId || !measurementTypeLonId) {
            return { lat: null, lng: null };
        }

        // Get measurements of location
        const lat = await this.get('measurements', ['time', 'value'], {
            ...filters,
            whereIn: [
                {
                    column: 'measurementTypeId',
                    array: [measurementTypeLatId]
                }
            ],
            orderBy: { column: 'time', type: 'desc' },
            limit: 1
        }).then(response => {
            return response?.data?.data?.measurements?.edges[0]?.value || null;
        });

        const lng = await this.get('measurements', ['time', 'value'], {
            ...filters,
            whereIn: [
                {
                    column: 'measurementTypeId',
                    array: [measurementTypeLonId]
                }
            ],
            orderBy: { column: 'time', type: 'desc' },
            limit: 1
        }).then(response => {
            return response?.data?.data?.measurements?.edges[0]?.value || null;
        });

        return { lat, lng };
    },
    checkExisting(modulename, fields, variables, options) {
        const uppercaseModule = (modulename.charAt(0).toUpperCase() + modulename.slice(1));
        let query = 'query listCheckExisting' + uppercaseModule + '($input: QueryInput){checkExisting' + uppercaseModule + '(input: $input){ edges {' + fields.join("\n") + '}}}';

        variables = {
            input: variables
        }

        return this.graphql(query, variables, options);
    },
    rotateImage(image_url) {
        return axios.post(this.api_url + '/images/rotate', {
            image: image_url
        });
    },
    downloadImage(dataURL) {
        return axios.post(this.api_url + '/images/download', {
            dataURL: dataURL
        }, {
            responseType: 'blob'
        });
    },
    generateResponseReportTemplate(responseId, options) {
        let params = '';
        if (options) {
            params = '?' + helper.serialize({ options: options });
        }
        return axios.get(this.api_url + '/report/response/template/' + responseId + params);
    },
    generateCustomTaskReport(taskId, template, oauthToken, folderId) {
        return axios.post(this.api_url + '/report/custom/task', {
            taskId: taskId,
            template: template,
            DriveOauthToken: oauthToken,
            DriveFolderId: folderId
        });
    },
    async getStorageObjectUrl(key) {
        return axios.get(this.backend_url + '/storage/' + key, { responseType: 'blob' }).then(async response => {
            const blob = response.data;
            const objectUrl = URL.createObjectURL(blob);

            // Update the source of the image.
            return objectUrl;
        });
    },
    import(settings, file) {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('endpoint', settings.endpoint);

        return axios.post(this.backend_url + '/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    exportJobTypeForm(templateId) {
        return axios.post(this.api_url + '/export/jobType/form', {
            templateId: templateId
        });
    },
    exportJobTypeConfig(template) {
        return axios.post(this.api_url + '/export/jobType/config', {
            template: template
        });
    },
    importJobTypeForm(file) {
        let formData = new FormData();
        formData.append('file', file);

        return axios.post(this.api_url + '/import/jobType/form', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    importJobTypeConfig(file) {
        let formData = new FormData();
        formData.append('file', file);

        return axios.post(this.api_url + '/import/jobType/config', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getDashboardFilters(content) {
        if (content.cells) {
            let dashboardfilters = [];

            let queryIds = [];
            for (let i = 0; i < content.cells.length; i++) {
                const cell = content.cells[i];
                if (cell.series) {
                    for (let serieIndex = 0; serieIndex < cell.series.length; serieIndex++) {
                        const serie = cell.series[serieIndex];
                        if (typeof serie.query == 'object') {
                            const queryfilters = helper.getQueryFilters(serie.query.content);
                            for (let j = 0; j < queryfilters.length; j++) {
                                const filter = queryfilters[j];
                                const existing = helper.getFilterByKey(dashboardfilters, filter.key);
                                if (!existing) {
                                    dashboardfilters.push(filter);
                                }
                            }
                        } else if (serie.query) {
                            queryIds = helper.mergeUnique(queryIds, [serie.query]);
                        }
                    }

                }
            }

            return this.get('templates', ['id', 'type', 'content'], {
                whereIn: {
                    column: 'id',
                    array: queryIds
                }
            }).then(response => {

                if (response.data.data.templates) {
                    let templates = response.data.data.templates.edges;
                    for (let i = 0; i < templates.length; i++) {
                        const template = templates[i];
                        if (template.type == 'QUERY') {
                            const queryfilters = helper.getQueryFilters(template.content);

                            for (let j = 0; j < queryfilters.length; j++) {
                                const filter = queryfilters[j];
                                const existing = helper.getFilterByKey(dashboardfilters, filter.key);
                                if (!existing) {
                                    dashboardfilters.push(filter);
                                }
                            }
                        }
                    }
                }

                return dashboardfilters;
            });
        }

        return [];
    },
    importUsers(file, options) {
        let formData = new FormData();
        formData.append('file', file);

        if (options) {
            formData.append('options', JSON.stringify(options));
        }

        return axios.post(this.api_url + '/import/users', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    export(objectname, fields, variables, moduleSettings) {

        if (moduleSettings && moduleSettings.customFields) {
            fields.push('customFields{customFieldId value}');
        }

        let query = 'query ' + objectname + '($input: QueryInput){' + objectname + '(input: $input){totalCount edges{' + fields.join("\n") + '}}}';

        if (!variables) {
            variables = {
                input: {
                    orderBy: {
                        column: "name",
                        type: "asc"
                    }
                }
            }
        } else {
            variables = {
                input: variables
            }
        }

        if (moduleSettings && moduleSettings.treeview) {
            if (moduleSettings.treeview.class) {
                if (!variables.input.where) {
                    variables.input.where = [];
                }
                variables.input.where.push({
                    column: 'class',
                    value: moduleSettings.treeview.class
                });
            }
        }

        let data = {
            objectname: objectname,
            query: query,
            variables: variables,
            settings: moduleSettings
        }

        return axios.post(this.api_url + '/export', data);
    },
    exportCustom(objectname, variables, options) {
        if (!variables) {
            variables = {
                input: {
                    orderBy: {
                        column: "name",
                        type: "asc"
                    }
                }
            }
        } else {
            variables = {
                input: variables
            }
        }

        let data = {
            objectname: objectname,
            variables: variables,
            options: options
        }

        return axios.post(this.api_url + '/export/custom', data);
    },
    exportCustomPreview(objectname, variables) {
        if (!variables) {
            variables = {
                input: {
                    orderBy: {
                        column: "name",
                        type: "asc"
                    }
                }
            }
        } else {
            variables = {
                input: variables
            }
        }

        let data = {
            objectname: objectname,
            variables: variables
        }

        return axios.post(this.api_url + '/export/custom/preview', data);
    },
    exportCustomSearchConfig(objectname) {
        let data = {
            objectname: objectname,
        }

        return axios.post(this.api_url + '/export/custom/search-config', data);
    },
    exportUsers(variables) {

        if (variables) {
            variables = {
                input: variables
            }
        }

        let data = {
            variables: variables
        }

        return axios.post(this.api_url + '/export/users', data);
    },
    cloudBackup(path, data) {
        return axios.post(this.api_url + '/backup/cloud/' + path, data);
    },
    exportBackup() {
        return axios.post(this.api_url + '/backup/export');
    },
    importBackup(file) {
        let formData = new FormData();
        formData.append('backup', file);

        return axios.post(this.api_url + '/backup/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    uploadStorageObject(data) {

        const formData = new FormData();

        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                formData.append(key, data[key]);
            }
        }

        return axios.post(this.api_url + '/storageObjects/upload', formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    deleteStorageObject(itemId) {
        return axios.delete(this.api_url + '/storageObjects', {
            data: {
                id: itemId
            }
        });
    },
    createStorageObject(itemId, tags) {
        return axios.post(this.api_url + '/storageObjects', {
            id: itemId,
            tags: JSON.stringify(tags)
        });
    },
    getTranslation(text, to) {
        let query = 'query singleTranslation($text: String!, $to: String!){translation(text: $text, to: $to){text}}';

        const variables = {
            text: text,
            to: to,
        }

        return this.graphql(query, variables);
    },
    getById(objectname, id, fields, variables) {
        let query = 'query single' + (objectname.charAt(0).toUpperCase() + objectname.slice(1)) + '($id: ID!){ ' + objectname + '(id: $id){' + fields.join(" ") + '}}';

        variables = {
            id: id,
            input: variables || {}
        }

        return this.graphql(query, variables);
    },
    getMe(fields, variables) {
        let query = 'query Me{ me{' + fields.join(" ") + '}}';

        return this.graphql(query, variables);
    },
    getRelated(objectname, id) {
        let query = 'query related' + objectname + 'Objects {' +
            'related' + objectname + 'Objects' + '(id: "' + id + '") {' +
            'id name type' +
            '}' +
            '}';

        return this.graphql(query);
    },
    getRoles(id) {
        let organizationId = id ? id : this.getUser().organizationId;

        return this.getById('organization', organizationId, ['availableRealmRoles{id name}']).then(result => {

            let roles = result.data.data.organization.availableRealmRoles;
            let settings = require('./settings');
            let ignore_roles = [];
            ignore_roles = ignore_roles.concat(settings.roles.exception, settings.roles.eod);

            let return_roles = [];

            for (let i = 0; i < roles.length; i++) {
                const role = roles[i];
                if (!ignore_roles.includes(role.name)) {
                    return_roles.push(role);
                }
            }

            return return_roles.sort((a, b) => (a.name > b.name) ? 1 : -1);
        });
    },
    distinct(modulename, fields, variables, options) {
        let query = 'query distinct' + (modulename.charAt(0).toUpperCase() + modulename.slice(1)) + '($input: QueryInput){distinct' + (modulename.charAt(0).toUpperCase() + modulename.slice(1)) + '(input: $input){distinct}}';

        if (!variables) {
            variables = {};
        }

        variables.fields = fields;

        variables = {
            input: variables
        }

        return this.graphql(query, variables, options);
    },
    // Bouwt de GraphQL-mutatie + variabelen voor een save (create of update).
    // Gedeelde logica die vroeger gedupliceerd stond in update() en create(),
    // zodat de keepalive-save (saveKeepalive) exact dezelfde query produceert.
    buildSaveQuery(objectname, data, options, mode = 'update') {
        let methodname = mode + objectname;
        let inputname = 'input';
        let inputtype = objectname + 'Input';
        let returnfields = ['id'];

        if (options) {
            if (options.methodname) {
                methodname = options.methodname;
            }
            if (options.inputname) {
                inputname = options.inputname;
            }
            if (options.inputtype) {
                inputtype = options.inputtype;
            }
            if (options.returnfields) {
                returnfields = options.returnfields;
            }
        }

        let query = 'mutation ' + methodname + '($input: ' + inputtype + ') {' +
            methodname + '(' + inputname + ': $input) {' +
            returnfields.join(' ') +
            '}' +
            '}';

        return {
            query: query,
            variables: {
                input: data
            }
        };
    },
    update(objectname, data, options) {
        const { query, variables } = this.buildSaveQuery(objectname, data, options, 'update');
        return this.graphql(query, variables);
    },
    updateMultiple(objectname, data, options) {
        return this.update(objectname, data, {
            methodname: 'update' + objectname + 's',
            inputname: 'listInput',
            inputtype: '[' + objectname + 'Input]',
            ...options
        })
    },
    requestRoutes(fields, data, options) {
        let query = 'mutation requestOptimizeRoutes($input: TimeInput) {requestOptimizeRoutes(input: $input) { edges{' +
            fields.join(' ') +
            '}}' +
            '}';

        let variables = {
            input: data
        }

        return this.graphql(query, variables, options);
    },
    create(objectname, data, options) {
        const { query, variables } = this.buildSaveQuery(objectname, data, options, 'create');
        return this.graphql(query, variables);
    },
    sendResponse(response, status_id, response_status, response_id) {
        return axios.post(this.api_url + '/report/save', {
            response: response,
            status: status_id,
            response_id: response_id,
            response_status: response_status,
            version: process.env.VUE_APP_VERSION
        });
    },
    sendMessage(user, data) {
        return axios.post(this.api_url + '/message/send', {
            data: data,
            user: user,
        });
    },
    createMultiple(objectname, data, options) {
        return this.create(objectname, data, {
            methodname: 'create' + objectname + 's',
            inputname: 'listInput',
            inputtype: '[' + objectname + 'Input]',
            ...options
        })
    },
    async saveMultiple(objectname, data, removeOrganization, options) {

        if (!removeOrganization) {
            // Always add organizationId
            let user = this.getUser();
            for (let i = 0; i < data.length; i++) {
                data[i].organizationId = user.organizationId;
            }
        }

        let to_update = [];
        let to_create = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].id) {
                to_update.push(data[i]);
            } else {
                to_create.push(data[i]);
            }
        }

        let updated = null;
        let created = null;
        // Check if update or create
        if (to_update.length > 0) {
            updated = await this.updateMultiple(objectname, to_update, options);
        }

        if (to_create.length > 0) {
            created = await this.createMultiple(objectname, to_create, options);
        }

        return {
            updated: updated,
            created: created
        };
    },
    save(objectname, data, options) {

        if (!options) {
            options = {};
        }

        //data.isActive = true;

        // Check if update or create
        if (data.id) {
            return this.update(objectname, data, options.update);
        } else {
            return this.create(objectname, data, options.create);
        }
    },
    // Zelfde create/update-routing als save(), maar via keepalive-fetch zodat de
    // save het sluiten van de tab overleeft (zie graphqlKeepalive).
    saveKeepalive(objectname, data, options) {
        if (!options) {
            options = {};
        }

        const mode = data.id ? 'update' : 'create';
        const subOptions = data.id ? options.update : options.create;
        const { query, variables } = this.buildSaveQuery(objectname, data, subOptions, mode);

        return this.graphqlKeepalive(query, variables);
    },
    async prepareCreateWorkflowData(data) {

        let workflowData = {};

        if (data.comments && data.comments[0]) {
            workflowData.description = data.comments[0].content;
        } else if (data.comment) {
            workflowData.description = data.comment;
        }

        const defaultTaskTypeSetting = await this.getOrganizationSetting('tasks.taskType.default.portal');
        if (defaultTaskTypeSetting) {
            workflowData.taskTypeId = defaultTaskTypeSetting.value;
        }

        if (data.storageObjects) {
            workflowData.storageObjects = data.storageObjects;
        } else if (data.images) {
            workflowData.storageObjects = data.images;
        }

        if (workflowData.storageObjects) {
            for (let i = 0; i < workflowData.storageObjects.length; i++) {
                workflowData.storageObjects[i].needsCopy = true;
            }
        }

        return workflowData;
    },
    delete(objectname, id, options) {

        const methodname = 'delete' + objectname;

        let inputtype = 'ID!';
        let inputname = 'id';
        if (options) {
            if (options.inputtype) {
                inputtype = options.inputtype;
            }
            if (options.inputname) {
                inputname = options.inputname;
            }
        }

        let query = 'mutation ' + methodname + '($input: ' + inputtype + ') {' + methodname + '(' + inputname + ': $input) }';

        let variables = {
            input: id
        }

        return this.graphql(query, variables);
    },
    getQueryGrouping(from, to) {
        return new Promise(async resolve => {
            let grouping = "1m";
            let diff = to.diff(from, 'm');

            let setting_key = 'dashboard.interval.default';
            if (diff <= 1440) { // 24u
                setting_key = 'dashboard.interval.day';
            } else if (diff <= 10080) { // 7 days
                setting_key = 'dashboard.interval.week';
            } else if (diff <= 44640) {
                setting_key = 'dashboard.interval.month';
            } else if (diff <= 525949) {
                setting_key = 'dashboard.interval.year';
            }

            const intervalSetting = await this.getOrganizationSetting(setting_key);
            if (intervalSetting) {
                grouping = intervalSetting.value;
            }

            resolve({
                diff: diff,
                grouping: grouping,
            });
        });

    },
    sendMail(addresses, type, options) {
        if (!options) {
            options = null;
        }

        return axios.post(this.api_url + '/mail', {
            addresses: addresses,
            type: type,
            options: options
        });
    },
    queryMeasurements(templateIndex, template, filters, options) {
        let query = 'query queryMeasurements($input: QueryMeasurementsInput){ queryMeasurements (input: $input) }';

        return this.graphql(query, {
            input: {
                unique: '' + templateIndex,
                // eodobjects runs the saved template with this id, not the SQL sent along.
                templateId: template.id || null,
                template: template,
                filters: filters,
                options: options,
            }
        }).then(response => {
            if (response.data.data.queryMeasurements) {
                return response.data.data.queryMeasurements;
            }

            return null;
        }).catch(e => {
            console.error('error query measurements', e);
            return null;
        });
    },
    rejectProposal(job) {
        return this.getById('task', job.id, ['id', 'availability{endDateTime endTimeUnspecified startDateTime recurrence}'])
            .then(response => {
                if (response.data.data && response.data.data.task) {
                    return response.data.data.task.availability;
                }

                return null;
            }).then(async availabilities => {

                if (!availabilities) {
                    const availabilitySetting = await this.getOrganizationSetting('projects.default.availability');
                    if (availabilitySetting && availabilitySetting.value) {
                        availabilities = JSON.parse(availabilitySetting.value);
                    }
                }

                if (availabilities) {
                    let changed = false;

                    for (let i = 0; i < availabilities.length; i++) {
                        const availability = new Availability(availabilities[i]);
                        const before = availability.contains(job.dueBeforeDate);
                        const after = availability.contains(job.dueAfterDate);
                        if (before) {
                            // Add exception for the job
                            availability.recurringAdvanced.exceptionDates.push(before);
                            changed = true;
                        } else if (after && before != after) {
                            availability.recurringAdvanced.exceptionDates.push(after);
                            changed = true;
                        }

                        availabilities[i] = availability.getSaveData();
                    }

                    if (changed) {
                        return this.save('Task', {
                            id: job.id,
                            availability: availabilities
                        });
                    }
                }

                return null;
            });
    },
    getDateByPeriodicityCode(periodicityCode, date) {
        let current_date = moment(date).format("YYYYMMDD\THHmmss") + 'Z';
        const rule = rrulestr('DTSTART:' + current_date + "\n" + periodicityCode + "COUNT=2");
        const dates = rule.all();
        if (dates[1]) {
            return moment(dates[1]);
        }

        return null;
    },
    getMeasurementTypeUnitFields(measurementType) {
        let fields = {};
        if (measurementType.unit && measurementType.unit.fields) {
            for (let i = 0; i < measurementType.unit.list.fields.length; i++) {
                const field = measurementType.unit.list.fields[i];
                fields[field.name] = measurementType.unit.fields[i].name;
            }
        }

        return fields;
    },
    getMeasurementTypeItems(measurementType) {
        let itemsByThreshold = {};
        let listItems = [];
        if (measurementType) {
            // if (measurementType.valueConfigListItems && measurementType.valueConfigListItems.length > 0) {
            //     listItems = measurementType.valueConfigListItems;
            // } else 

            if (measurementType.valueConfigList && measurementType.valueConfigList.listItems && measurementType.valueConfigList.listItems.length > 0) {
                listItems = measurementType.valueConfigList.listItems;
            }
        }

        for (let i = 0; i < listItems.length; i++) {
            const listItem = listItems[i];
            itemsByThreshold[listItem.threshold] = listItem;
        }

        return itemsByThreshold;
    },
    getProductVariableById(template, variableId) {
        if (template.content.variables) {
            for (let i = 0; i < template.content.variables.length; i++) {
                const variable = template.content.variables[i];
                if (variable.value == variableId) {
                    return variable;
                }
            }
        }

        return null;
    },
    saveAlarmRule(template) {
        const temp = new Template(template);
        const data = temp.getSaveData();

        return this.save('Template', data);
    },
    generateMeasurementTypeQuery(measurementType, defaults) {

        let query = {
            type: 'QUERY',
            object: 'MEASUREMENT_TYPE',
            access: 'PUBLIC',
            isSystem: true,
            isActive: true,
            name: measurementType.name,

            content: {
                source: 'measurements',
                // measurementTypes: [{
                //     aggregation: 'last',
                //     object: {
                //         id: measurementType.id,
                //         name: measurementType.name,
                //         description: measurementType.description
                //     }
                // }],
                fields: [
                    {
                        key: 'time',
                        aggregation: null
                    },
                    {
                        key: 'value',
                        aggregation: 'last'
                    }],
                dynamic_filters: [{
                    field: {
                        endpoint: 'jobTypes',
                        key: 'job_type_id',
                        title: 'Jobtype',
                    },
                    value: 'Jobtype',
                    isHidden: true
                }, {
                    field: {
                        endpoint: 'resolveProjects',
                        key: 'project_id',
                        title: 'Project',
                    },
                    value: 'Project',
                    isHidden: true
                },
                {
                    field: {
                        endpoint: 'resolveUsers',
                        key: 'owner_id',
                        title: 'Eigenaar',
                    },
                    value: 'Eigenaar'
                },
                {
                    field: {
                        endpoint: 'resolveProducts',
                        key: 'product_id',
                        title: 'Asset',
                    },
                    value: 'Asset'
                }
                ],
                filters: [
                    {
                        field: {
                            key: 'measurement_type_id'
                        },
                        operator: '=',
                        value: measurementType.id
                    }
                ],
                group: ['time']
            }
        }

        if (defaults.query) {
            query = helper.mergeObjects(query, defaults.query);
        }

        return query;
    },
    generateFormTemplateDashboard(item, defaults) {
        const template = helper.getTemplateByType(item.templates, 'FORM');

        let measurementTypeIds = [];
        for (let pageIndex = 0; pageIndex < template.content.pages.length; pageIndex++) {
            const page = template.content.pages[pageIndex];
            for (let cellIndex = 0; cellIndex < page.cells.length; cellIndex++) {
                const cell = page.cells[cellIndex];
                if (cell.typeId == 'measurementType' && !measurementTypeIds.includes(cell.settings.measurementTypeId)) {
                    measurementTypeIds.push(cell.settings.measurementTypeId);
                }
            }
        }

        return this.generateDashboardForMeasurements(measurementTypeIds, defaults, template);
    },
    getDashboardTabsFilter(params) {
        const dashboardTabs = [];
        if (params.company_id) {
            dashboardTabs.push({
                object: 'COMPANY',
                id: params.company_id.id ? params.company_id.id : params.company_id
            });
        }
        if (params.project_id) {
            dashboardTabs.push({
                object: 'PROJECT',
                id: params.project_id.id ? params.project_id.id : params.project_id
            });
        }
        if (params.product_type_id) {
            dashboardTabs.push({
                object: 'PRODUCT_TYPE',
                id: params.product_type_id.id ? params.product_type_id.id : params.product_type_id
            });
        }
        if (params.product_id) {
            dashboardTabs.push({
                object: 'PRODUCT',
                id: params.product_id.id ? params.product_id.id : params.product_id
            });
        }
        if (params.job_type_id) {
            dashboardTabs.push({
                object: 'JOB_TYPE',
                id: params.job_type_id.id ? params.job_type_id.id : params.job_type_id
            });
        }
        if (params.task_id) {
            dashboardTabs.push({
                object: 'TASK',
                id: params.task_id.id ? params.task_id.id : params.task_id
            });
        }

        if (!dashboardTabs[0]) {
            dashboardTabs.push({
                object: 'ORGANIZATION'
            });
        }

        return dashboardTabs;
    },
    async generateCompanyDashboard(companyId, defaults) {
        let newTemplate = {
            type: 'DASHBOARD',
            object: 'COMPANY',
            access: 'PROTECTED',
            description: '',
            content: {
                style: {
                    color1: null,
                    color2: null
                },
                cells: []
            },
            ...defaults.template
        }

        if (defaults.dashboard) {
            newTemplate = helper.mergeObjects(newTemplate, defaults.dashboard);
        }

        return newTemplate;

    },
    async generateProjectDashboard(projectId, defaults) {
        let newTemplate = {
            type: 'DASHBOARD',
            object: 'PROJECT',
            access: 'PROTECTED',
            description: '',
            content: {
                style: {
                    color1: null,
                    color2: null
                },
                cells: []
            },
            ...defaults.template
        }

        if (defaults.dashboard) {
            newTemplate = helper.mergeObjects(newTemplate, defaults.dashboard);
        }

        newTemplate.content.cells.push({
            w: 6,
            h: 9,
            graph: {
                fields: [
                    {
                        serie: 0,
                        key: "task_id",
                        fieldKey: "task_id",
                        label: "Taak",
                        visible: true,
                        view: "custom-link",
                        options: {
                            to: {
                                name: 'dashboard.task',
                                params: {
                                    id: '{{value}}'
                                }
                            }
                        }
                    },
                    {
                        serie: 0,
                        key: "project_id",
                        fieldKey: "project_id",
                        label: "Project",
                        visible: false,
                        view: "resolved"
                    }
                ]
            },
            i: _.uniqueId(),
            title: "Workflows",
            typeId: "table",
            x: 0,
            y: 0,
            series: [
                {
                    label: "Project workflows",
                    filters: [],
                    query: {
                        access: "PUBLIC",
                        name: "Project workflows",
                        type: "QUERY",
                        isActive: true,
                        content: {
                            raw: "select tasks.id, parent.id as task_id, tasks.project_id from tasks\nINNER JOIN (SELECT id, name FROM tasks) as parent ON parent.id = tasks.parent_task_id\nWHERE tasks.category = 'JOB' and tasks.is_deleted = false and tasks.status_code != 'done' [[dynamic_filter:project_id]]",
                            fields: [
                                {
                                    key: "task_id",
                                    isCustom: true,
                                    originalKey: "task_id"
                                },
                                {
                                    key: "product_id",
                                    isCustom: true,
                                    originalKey: "product_id"
                                }
                            ],
                            source: null,
                            filters: [],
                            dynamic_filters: [
                                {
                                    field: {
                                        key: "project_id",
                                        endpoint: "projects"
                                    },
                                    value: "Project"
                                }
                            ]
                        }
                    }
                }
            ],
            index: 6,
            moved: false
        });
        return newTemplate;

    },
    async generateDashboardForMeasurements(measurementTypeIds, defaults, template) {

        const measurementTypes = await this.get('measurementTypes', ['id', 'name', 'isWritable', 'description', 'valueConfigList{id name itemType listItems{id name color}}', 'valueConfigListItems{id name color}', 'unit{id name color fields{name}}', 'dashboardConfig', 'formConfig{category type enabled required photo photoRequired photoMax comment commentRequired default defaultValue values}'], {
            whereIn: {
                column: 'id',
                array: measurementTypeIds
            }
        })
            .then(async response => {
                return response.data.data.measurementTypes.edges;
            });

        let graphs = {
            tile: {
                graph: {
                    field: {
                        field: {
                            key: 'value'
                        },
                        key: 'last_value'
                    },
                    fields: [{
                        fieldKey: 'time',
                        key: 'last_time',
                    }]
                }
            },
            profile: {
                groupAll: true
            },
            line: {
                serie: {
                    xAxis: {
                        field: {
                            key: 'time'
                        },
                        key: 'time'
                    },
                    yAxis: {
                        field: {
                            key: 'value'
                        },
                        key: 'last_value'
                    }
                },
                groupByUnit: false,
                groupByMeasurementType: true
            },
            vbar: {
                groupByUnit: false,
                groupByMeasurementType: true
            },
            liquid: {},
        }

        for (let i = 0; i < measurementTypes.length; i++) {
            const measurementType = new MeasurementType(measurementTypes[i]);

            let queryTemplate = this.generateMeasurementTypeQuery(measurementType, defaults);

            // Filling all supported graph types with their measurementTypes
            for (const graphType in graphs) {
                if (Object.hasOwnProperty.call(graphs, graphType)) {
                    if (measurementType.dashboardConfig && measurementType.dashboardConfig.graphs.includes(graphType)) {
                        const config = graphs[graphType];

                        let unique = config.groupAll ? 'all' : ((config.groupByUnit && measurementType.unit) ? measurementType.unit.id : measurementType.id);

                        if (!graphs[graphType].cells) {
                            graphs[graphType].cells = {};
                        }

                        // Get products linked to measurementType in form
                        const productIds = [];
                        const variableIds = [];
                        if (template) {
                            for (let pageIndex = 0; pageIndex < template.content.pages.length; pageIndex++) {
                                const page = template.content.pages[pageIndex];
                                for (let cellIndex = 0; cellIndex < page.cells.length; cellIndex++) {
                                    const cell = page.cells[cellIndex];
                                    if (cell.typeId == 'measurementType' && cell.settings.measurementTypeId == measurementType.id) {
                                        if (cell.settings.product) {
                                            if (cell.settings.product.id) {
                                                productIds.push(cell.settings.product.id);
                                            } else if (cell.settings.product.variable) {
                                                variableIds.push(cell.settings.product.variable);
                                                // const variable = this.getProductVariableById(template, cell.settings.product.variable);
                                                // if (variable.product && variable.product.id) {
                                                //     productIds.push(variable.product.id);
                                                // }
                                            }
                                        }
                                    }
                                }
                            }
                        }


                        if (config.groupAll || config.groupByMeasurementType) {
                            if (!graphs[graphType].cells[unique]) {
                                graphs[graphType].cells[unique] = [];
                            }

                            graphs[graphType].cells[unique].push({
                                measurementType: measurementType,
                                queryTemplate: queryTemplate
                            });
                        } else {
                            if (variableIds.length > 0) {
                                for (let variableIndex = 0; variableIndex < variableIds.length; variableIndex++) {
                                    const variableId = variableIds[variableIndex];
                                    const cellId = unique + '_' + variableId;
                                    if (!graphs[graphType].cells[cellId]) {
                                        graphs[graphType].cells[cellId] = [];
                                    }

                                    graphs[graphType].cells[cellId].push({
                                        variable_id: variableId,
                                        measurementType: measurementType,
                                        queryTemplate: queryTemplate
                                    });
                                }
                            } else if (productIds.length > 0) {
                                for (let productIndex = 0; productIndex < productIds.length; productIndex++) {
                                    const productId = productIds[productIndex];

                                    const cellId = unique + '_' + productId;
                                    if (!graphs[graphType].cells[cellId]) {
                                        graphs[graphType].cells[cellId] = [];
                                    }

                                    graphs[graphType].cells[cellId].push({
                                        product_id: productId,
                                        measurementType: measurementType,
                                        queryTemplate: queryTemplate
                                    });
                                }
                            } else {
                                const cellId = unique + '_general';
                                if (!graphs[graphType].cells[cellId]) {
                                    graphs[graphType].cells[cellId] = [];
                                }
                                graphs[graphType].cells[cellId].push({
                                    measurementType: measurementType,
                                    queryTemplate: queryTemplate
                                });
                            }
                        }

                    }
                }
            }
        }

        let newTemplate = {
            type: 'DASHBOARD',
            object: 'JOB_TYPE',
            access: 'PROTECTED',
            description: '',
            content: {
                style: {
                    color1: null,
                    color2: null
                },
                cells: []
            },
            ...defaults.template
        }

        if (defaults.dashboard) {
            newTemplate = helper.mergeObjects(newTemplate, defaults.dashboard);
        }

        const getNewCell = function (cellType, defaults, xPos, yPos, cardIndex) {
            let newCell = cellType.defaultTile;
            newCell.typeId = cellType.key;
            newCell.i = cardIndex;
            newCell.x = xPos;
            newCell.y = yPos;
            newCell.title = '';

            if (cellType.graph) {
                newCell.graph = helper.mergeObjects(newCell.graph, cellType.graph);
            }

            newCell = helper.mergeObjects(newCell, defaults);

            return newCell;
        }

        let cardIndex = 0;
        let xPos = defaults.xPos || 0;
        let yPos = defaults.yPos || 0;

        const maxCols = 12;
        let maxH = defaults.maxH || 0;

        for (const graphType in graphs) {
            if (Object.hasOwnProperty.call(graphs, graphType)) {
                const config = graphs[graphType];
                const cellType = CELL_TYPES[graphType];

                if (config.cells) {
                    for (const unique in config.cells) {
                        if (Object.hasOwnProperty.call(config.cells, unique)) {
                            const cells = config.cells[unique];

                            const measurementType = cells[0].measurementType;

                            if ((xPos + cellType.defaultTile.w) > maxCols) {
                                xPos = 0;
                                yPos = yPos + maxH;
                            }

                            let series = [];
                            let colors = [];

                            const baseColor = measurementType.unit ? measurementType.unit.color : null;

                            for (let i = 0; i < cells.length; i++) {
                                const cell = cells[i];

                                let graph_defaults = {};
                                if (defaults && defaults.cellTypes && defaults.cellTypes[cellType.key]) {
                                    graph_defaults = defaults.cellTypes[cellType.key];
                                }

                                if (config.serie) {

                                    graph_defaults = helper.mergeObjects(graph_defaults, config.serie);
                                }

                                const color = baseColor ? helper.increaseBrightness(baseColor, i * 25) : null;
                                const serie = helper.mergeObjects({
                                    query: cell.queryTemplate,
                                    label: cell.measurementType.name,
                                }, graph_defaults);

                                if (graphType == 'tile' && cell.variable_id) {
                                    serie.filters = [
                                        {
                                            field: {
                                                key: 'product_id',
                                            },
                                            operator: '=',
                                            value: {
                                                isVariable: true,
                                                id: cell.variable_id
                                            }
                                        }
                                    ]
                                }

                                series.push(serie);

                                if (color) {
                                    colors.push(color);
                                }
                            }

                            const cellName = config.groupAll ? null : (config.groupByUnit ? (measurementType.unit ? measurementType.unit.name : measurementType.name) : measurementType.name + (measurementType.unit && measurementType.unit.fields && measurementType.unit.fields[2] ? ' (' + measurementType.unit.fields[2].name + ')' : ''));
                            const cellData = {
                                title: cellName,
                                series: series,
                                graph: config.graph || {}
                            };

                            if (graphType == 'tile') {
                                const cell = cells[0];
                                cellData.graph.request = {
                                    isWritable: measurementType.isWritable,
                                    project_id: { isVariable: true, id: 'project_id' },
                                    job_type_id: { isVariable: true, id: 'job_type_id' },
                                    product_id: cell.variable_id ? { isVariable: true, id: cell.variable_id } : (cell.product_id ? { id: cell.product_id } : null),
                                    owner_id: { isVariable: true, id: 'owner_id' },
                                }
                            }

                            const newCell = getNewCell(cellType, cellData, xPos, yPos, cardIndex);

                            newTemplate.content.cells.push(newCell);

                            if (cellType.defaultTile.h > maxH) {
                                maxH = cellType.defaultTile.h;
                            }

                            xPos = xPos + cellType.defaultTile.w;

                            cardIndex++;
                        }
                    }
                }
            }
        }

        return newTemplate;
    },
    async generateProductTypeDashboard(productTypeId, defaults = {}) {
        let productIds = [];
        const productType = await this.getById('productType', productTypeId, ['id', 'products{id}']).then(response => {
            return response?.data?.data?.productType;
        });

        productIds = productType?.products?.map(item => item.id);

        if (!productIds[0]) {
            return null;
        }

        // Get measurementTypeIds of measurementTypes with measurements of this project
        const measurementTypeIds = await this.distinct('measurements', ['measurement_type_id'], {
            whereIn: [
                {
                    column: 'productId',
                    array: productIds
                }
            ],
            where: [
                {
                    column: 'time',
                    operator: '>',
                    value: (new Date(new Date().setFullYear(new Date().getFullYear() - 1)))
                }
            ]
        }).then(response => {
            if (response.data.data && response.data.data.distinctMeasurements) {
                return response.data.data.distinctMeasurements.distinct;
            }
            return null;
        });

        if (!measurementTypeIds) {
            return null;
        }

        return this.generateDashboardForMeasurements(measurementTypeIds, defaults);
    },
    async generateProductDashboard(productId, projectId, defaults) {
        if (!projectId) {
            const product = await this.getById('product', productId, ['id', 'project{id}']).then(response => {
                return response?.data?.data?.product;
            });

            projectId = product?.project?.id;
        }
        // Get measurementTypeIds of measurementTypes with measurements of this project
        const measurementTypeIds = await this.distinct('measurements', ['measurement_type_id'], {
            where: [
                {
                    column: 'productId',
                    operator: '=',
                    value: productId
                },
                {
                    column: 'projectId',
                    operator: '=',
                    value: projectId
                },
                {
                    column: 'time',
                    operator: '>',
                    value: (new Date(new Date().setFullYear(new Date().getFullYear() - 1)))
                }
            ]
        }).then(response => {
            if (response.data.data && response.data.data.distinctMeasurements) {
                return response.data.data.distinctMeasurements.distinct;
            }
            return null;
        });

        if (!measurementTypeIds) {
            return null;
        }

        if (!defaults) {
            defaults = {};
        }

        defaults.xPos = 6;
        defaults.maxH = 9;

        return this.generateDashboardForMeasurements(measurementTypeIds, defaults).then(template => {
            template.content.cells.push({
                w: 6,
                h: 9,
                graph: {
                    fields: [
                        {
                            serie: 0,
                            key: "task_id",
                            fieldKey: "task_id",
                            label: "Taak",
                            visible: true,
                            view: "custom-link",
                            options: {
                                to: {
                                    name: 'dashboard.task',
                                    params: {
                                        id: '{{value}}'
                                    }
                                }
                            }
                        },
                        {
                            serie: 0,
                            key: "product_id",
                            fieldKey: "product_id",
                            label: "Asset",
                            visible: false,
                            view: "resolved"
                        }
                    ]
                },
                i: _.uniqueId(),
                title: "Workflows",
                typeId: "table",
                x: 0,
                y: 0,
                series: [
                    {
                        label: "Product workflows",
                        filters: [],
                        query: {
                            access: "PUBLIC",
                            name: "Product workflows",
                            type: "QUERY",
                            isActive: true,
                            content: {
                                raw: "select tasks.id, parent.id as task_id, tasks_products.product_id  from tasks\nINNER JOIN tasks_products ON tasks_products.task_id  = tasks.id\nINNER JOIN tasks as parent ON parent.id = tasks.parent_task_id\nWHERE tasks.category = 'JOB' and tasks.is_deleted = false and tasks.status_code != 'done' [[dynamic_filter:product_id]]",
                                fields: [
                                    {
                                        key: "task_id",
                                        isCustom: true,
                                        originalKey: "task_id"
                                    },
                                    {
                                        key: "product_id",
                                        isCustom: true,
                                        originalKey: "product_id"
                                    }
                                ],
                                source: null,
                                filters: [],
                                dynamic_filters: [
                                    {
                                        field: {
                                            key: "product_id",
                                            endpoint: "products"
                                        },
                                        value: "Asset"
                                    }
                                ]
                            }
                        }
                    }
                ],
                index: 6,
                moved: false
            });
            return template;
        });
    },
    generateJobTypeDashboard(jobTypeId, defaults) {

        return this.getById('jobType', jobTypeId, ['id', 'name', 'templates{id name type content}'])
            .then(response => {
                const jobType = response.data.data.jobType;
                // defaults.template = {
                //     name: jobType.name
                // }
                return this.generateFormTemplateDashboard(jobType, defaults);
            });
    },
    getTemplateByType(templates, type) {
        if (templates) {
            for (let i = 0; i < templates.length; i++) {
                const template = templates[i];
                if (template.type == type) {
                    return template;
                }
            }
        }
        return null;
    },
    getDefaultJobFilters() {
        const me = this.getUser();

        let filters = [];

        const proposedMaxDate = moment().subtract(2, 'weeks');

        let proposedJobsFilter = {
            "config": {
                "icon": "mdi-calendar",
                "type": "property",
                "label": "Planningsdatum",
                "filter": "dueRequestDate",
                "operator": ">",
                "selected": false,
            },
            "result": {
                "id": proposedMaxDate.startOf('day').toISOString(),
                "selected": false,
                "search_title": '> ' + proposedMaxDate.format('YYYY-MM-DD')
            }
        };

        filters.push({
            value: "proposed_tasks",
            name: 'Voorgestelde taken',
            content: {
                "filter": [proposedJobsFilter]
            }
        });

        filters.push({
            value: null,
            name: 'Alle taken',
            content: {
                filter: [{
                    "config": {
                        "icon": "mdi-account-outline",
                        "type": "fixed",
                        "label": "Uit te voeren door",
                        "filter": "userId",
                        "selected": false,
                        "settings": {
                            "title": "{firstName} {lastName} ({username})",
                            "fields": ["firstName", "lastName", "username"],
                            "module": "searchUsers",
                            "options": {
                                "enabled": true
                            },
                        }
                    },
                    "result": {
                        "id": me.id,
                        "lastName": me.lastName,
                        "selected": false,
                        "username": me.username,
                        "firstName": me.firstName,
                        "search_title": me.getFullName()
                    }
                }]
            }
        });



        let myJobsFilter = {
            "config": {
                'icon': 'mdi-account-outline',
                'label': 'Verantwoordelijke',
                'type': 'relation',
                'settings': {
                    'module': 'searchUsers',
                    'fields': ['firstName', 'lastName', 'username'],
                    'title': '{firstName} {lastName} ({username})',
                    'options': {
                        enabled: true
                    },
                    'table': 'tasks_responsible_users',
                    'id': 'userId',
                },
                'filter': 'responsibleUsers'
            },
            "result": {
                "id": me.id,
                "lastName": me.lastName,
                "selected": false,
                "username": me.username,
                "firstName": me.firstName,
                "search_title": '{firstName} {lastName} ({username})'.replace('{firstName}', me.firstName).replace('{lastName}', me.lastName).replace('{username}', me.username)
            }
        };

        filters.push({
            value: "my_tasks",
            name: 'Mijn taken',
            content: {
                "filter": [myJobsFilter]
            }
        });

        let team_filter = [];
        if (me.groups) {
            for (let i = 0; i < me.groups.length; i++) {
                const group = me.groups[i];
                const team_filter_content = {
                    "config": {
                        "icon": "mdi-account-group-outline",
                        "type": "module",
                        "label": "Team",
                        "filter": "responsibleGroupId",
                        "selected": false,
                        "settings": {
                            "title": "{name}",
                            "fields": [
                                "name"
                            ],
                            "module": "groups"
                        }
                    },
                    "result": {
                        "id": group.id,
                        "name": group.name,
                        "selected": false,
                        "search_title": group.name
                    }
                };

                team_filter.push(team_filter_content);
            }

            filters.push({
                value: "my_team",
                name: 'Mijn team(s)',
                content: {
                    "filter": team_filter
                }
            });
        }

        return filters;
    },
    duplicate(objectname, id, fields) {

        if (!fields) {
            fields = ['id'];
        }

        const methodname = 'duplicate' + objectname;
        const inputtype = 'ID!';
        const inputname = 'id';

        let query = 'mutation ' + methodname + '($input: ' + inputtype + ') {' + methodname + '(' + inputname + ': $input){' + fields.join(" ") + '} }';

        let variables = {
            input: id
        }

        return this.graphql(query, variables);
    },
    duplicateTemplate(endpoint, itemId) {
        return this.getById(endpoint, itemId, ['templates{name description type object content}'])
            .then(async response => {
                if (response.data.data[endpoint]) {
                    const item = response.data.data[endpoint];
                    if (item.templates && item.templates[0]) {
                        return helper.getTemplateByType(item.templates, 'FORM');
                    }
                }
            });
    },
    async rejectWorkflow(taskId, motivation) {
        const result = await this.update('RejectTask', {
            id: taskId,
            motivation: motivation
        }, {
            methodname: 'rejectTask',
        });

        if (result.data.data && result.data.data.rejectTask) {
            const workflow = result.data.data.rejectTask;
            return workflow;
        }

        return null;
    },
    async cancelWorkflow(taskId, motivation) {
        const result = await this.update('CancelTask', {
            id: taskId,
            motivation: motivation
        }, {
            methodname: 'cancelTask',
        });

        if (result.data.data && result.data.data.cancelTask) {
            const workflow = result.data.data.cancelTask;
            return workflow;
        }

        return null;
    },
    async submitWorkflow(taskId, options) {

        const result = await this.update('SubmitTask', {
            id: taskId,
            ...options
        }, {
            methodname: 'submitTask',
            returnfields: ['id', 'stepType', 'estimatedDuration', 'dueBeforeDate', 'dueAfterDate', 'name', 'category', 'jobType{id}']
        });

        // A USER_ERROR (e.g. a missing workflow template) is already shown by
        // graphql(), which then answers null.
        if (!result) {
            return null;
        }

        // Surface any other backend GraphQL error so the caller can show it,
        // instead of returning null and leaving the user waiting.
        if (result.data && result.data.errors && result.data.errors.length) {
            throw result.data.errors;
        }

        if (result.data.data && result.data.data.submitTask) {
            const newJob = result.data.data.submitTask;

            return newJob;
        }

        return null;
    },
    async saveWorkflow(data, options) {

        const result = await this.update('SaveTask', {
            data: data,
        }, {
            methodname: 'saveTask',
            returnfields: ['id', 'stepType', 'estimatedDuration', 'dueBeforeDate', 'dueAfterDate', 'name', 'category', 'jobType{id}'],
            ...options,
        });

        // Surface backend GraphQL errors (e.g. workflow validation) so the caller
        // can show them, instead of silently returning null and failing later.
        if (result && result.data && result.data.errors && result.data.errors.length) {
            throw result.data.errors;
        }

        if (result.data.data && result.data.data.saveTask) {
            return result.data.data.saveTask;
        }

        return null;
    },
    clearCache() {
        return axios.post(this.graphql_url, {
            clearCache: true
        });
    },
    workflowReturnToPlan(workflowId) {
        return this.getById('task', workflowId, ['id', 'name', 'stepId', 'templates{id type content}', 'company{id}', 'project{id}', 'service{id}', 'taskType{id}'])
            .then(async response => {
                const workflow = new Task(response.data.data.task);

                if (!workflow.templates || (workflow.templates && !workflow.templates[0])) {
                    return false;
                }

                const template = helper.getTemplateByType(workflow.templates, 'WORKFLOW');
                const activePage = template.getPageInfo(workflow.stepId);

                for (let i = activePage.pageIndex; i > 0; i--) {
                    const page = template.content.pages[i];
                    for (let cellIndex = 0; cellIndex < page.cells.length; cellIndex++) {
                        const cell = page.cells[cellIndex];
                        if (cell.settings.type && cell.settings.type == 'plan') {

                            const newData = {
                                id: cell.jobId,
                                statusCode: 'to_do',
                                isJobActive: true
                            };

                            //If smart planning module disabled, delete users and time
                            const optimize = this.getOrganizationSetting('planning.optimizeWaypoints').value;
                            if (optimize != true) {
                                newData.responsibleUsers = [];
                                newData.dueAfterDate = null;
                                newData.dueBeforeDate = null;
                            }

                            this.save('Task', newData);

                            template.setCellValue(cell.id, 'active', true);
                            template.setCellValue(cell.id, 'finished', false);

                            workflow.stepId = page.id;
                            workflow.stepName = page.name;
                            workflow.dueBeforeDate = null;
                            workflow.dueAfterDate = null;
                            workflow.statusCode = 'in_progress';

                            await workflow.save();

                            return {
                                cell: cell
                            }
                        } else {

                            if (cell.jobId) {
                                await this.delete('Task', cell.jobId);
                                template.setCellValue(cell.id, 'jobId', null);
                            }

                            template.setCellValue(cell.id, 'active', false);
                            template.setCellValue(cell.id, 'finished', false);
                        }
                    }
                }

                return null;


            });
    },
};